// TermsMetaData.js
// TermsMetaData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const TermsMetaData = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://www.meatbuddy.in/terms/#webpage",
        "url": "https://www.meatbuddy.in/terms",
        "name": "Terms and Conditions - Meat Buddy",
        "description": "Terms and conditions for using Meat Buddy's fresh meat delivery service in Bengaluru. Important guidelines about ordering, delivery, and usage.",
        "isPartOf": { "@id": "https://www.meatbuddy.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "https://www.meatbuddy.in",
                "name": "Home"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@id": "https://www.meatbuddy.in/terms",
                "name": "Terms & Conditions"
              }
            }
          ]
        }
      },
      {
        "@type": "Article",
        "@id": "https://www.meatbuddy.in/terms/#article",
        "headline": "Meat Buddy Terms and Conditions",
        "description": "Legal terms and conditions for using our meat delivery service",
        "articleBody": "Complete terms of service for ordering and delivery of fresh meat products",
        "publisher": {
          "@id": "https://www.meatbuddy.in/#organization"
        },
        "datePublished": "2025-03-01",
        "dateModified": "2025-03-01"
      },
      {
        "@type": "FAQPage",
        "@id": "https://www.meatbuddy.in/terms/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What are the delivery terms?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We deliver between 9 AM to 6 PM daily. Minimum order value is ₹250 for free delivery in select areas of Bengaluru."
            }
          },
          {
            "@type": "Question",
            "name": "What are the payment terms?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We accept online payments and Cash on Delivery. All transactions are processed through secure payment gateways."
            }
          },
          {
            "@type": "Question",
            "name": "What are the cancellation terms?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Orders can be cancelled before processing begins. Refunds for online payments are processed within 48 hours."
            }
          }
        ]
      },
      {
        "@type": "WebSite",
        "@id": "https://www.meatbuddy.in/#website",
        "url": "https://www.meatbuddy.in",
        "name": "Meat Buddy",
        "publisher": {
          "@type": "Organization",
          "name": "Vistara Farms Private Limited",
          "alternateName": "Meat Buddy"
        }
      }
    ]
  };

  return (
    <Helmet>
      <title>Terms & Conditions - Meat Buddy | Fresh Meat Delivery Service</title>
      <meta name="title" content="Terms & Conditions - Meat Buddy" />
      <meta name="description" content="Read Meat Buddy's terms and conditions for fresh meat delivery service in Bengaluru. Important information about ordering, delivery, payments, cancellations, and usage policies." />
      <meta name="keywords" content="meat buddy terms, delivery terms, payment terms, cancellation policy, meat delivery terms bangalore" />
      <meta name="robots" content="noindex, follow" />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.meatbuddy.in/terms" />
      <meta property="og:title" content="Terms & Conditions - Meat Buddy" />
      <meta property="og:description" content="Important terms and conditions for using Meat Buddy's premium meat delivery service in Bengaluru." />
      
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Terms & Conditions - Meat Buddy" />
      <meta name="twitter:description" content="Read our terms of service for premium meat delivery in Bengaluru." />
      
      <link rel="canonical" href="https://www.meatbuddy.in/terms" />
      
      {/* Security Headers */}
      <meta http-equiv="Content-Security-Policy" content="default-src 'self'" />
      <meta http-equiv="X-Content-Type-Options" content="nosniff" />
      <meta http-equiv="X-Frame-Options" content="DENY" />
      
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};